import {
  getApp,
  getApps,
  initializeApp,
} from "firebase/app";

import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBcN3DP8dUTRtQdgg7U4PCYUf11hzGpEuU",
  authDomain: "harmonauria-music.firebaseapp.com",
  projectId: "harmonauria-music",
  storageBucket: "harmonauria-music.firebasestorage.app",
  messagingSenderId: "572209288312",
  appId: "1:572209288312:web:79f6e4d001ef7ff850098d",
  measurementId: "G-Y2E5ECYLZQ",
};

const app = getApps().length
  ? getApp()
  : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

/*
 * Cette région doit correspondre exactement à la région
 * utilisée dans le code de vos fonctions appelables.
 */
export const functions = getFunctions(app, "europe-west1");

export default app;